// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__S2aO1","date":"Card_date__j0RKN","title":"Card_title__QHhlF","text":"Card_text__iOVpm","button":"Card_button__p9RnE","type":"Card_type__SIUCs"};